<template>
  <div class="input-group bootstrap-touchspin input-group-lg ">
    <span class="input-group-btn input-group-prepend bootstrap-touchspin-injected">
        <button class="btn btn-primary bootstrap-touchspin-down" @click="valueChange(value - 1,value)" type="button"><svg xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus">
                <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
        </button>
    </span>

    <b-form-input
 
      :size="size"
      :value="value"
      type="number"      
      :min="min"
      :max="max"
      class="touchspin form-control border-dark border-width "
      number
      @update="valueChange"
    />
    <span class="input-group-btn input-group-append bootstrap-touchspin-injected">
        <button
            class="btn btn-primary bootstrap-touchspin-up" type="button"  @click="valueChange(value + 1,value)" >
            <svg xmlns="http://www.w3.org/2000/svg" width="24"
                height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="feather feather-plus">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
        </button>
    </span>
</div>
</template>

<script>
export default {
  props: {
    // id: {
    //   type: String,
    //   required: true
    // },

    min:{
      type:Number,
      default:0
    },

    max:{
      type:Number,
      default:Number.MAX_VALUE
    },

    size: {
      type: String,
      required: false,
      default: 'md',
      validator: function (value) {
        return ['sm', 'md', 'lg'].includes(value)
      }
    },

    value: {
      // type: Number,
      required: true
    }
  },

  methods: {
    valueChange (newValue,oldVal) {
      if(newValue < this.min || newValue > this.max ){
        this.$emit('input', 0)
        return
      }
      if (newValue <= 0) {
        this.$emit('input', 0)
      } else {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style scoped>
/* Remove up and down arrows inside number input */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.border-width{
  border-width: 1px !important;
}
</style>